//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { date } from 'quasar'
import WarningBanner from './WarningBanner.vue'
import DateTimeField from './../components/Field/DateTimeField.vue'
import DateIntervalField from './../components/Field/DateIntervalField.vue'
import ItemsSearchField from './../components/Field/ItemsSearchField.vue'
import AddressField from './../components/Field/AddressField.vue'
import CardSeparator from './../components/Card/CardSeparator.vue'

function getButtonColorsByConfigColor (color) {
  if (color === 'green') {
    return { bgColor: 'green', textColor: 'white' }
  } else if (color === 'red') {
    return { bgColor: 'red', textColor: 'white' }
  } else if (color === 'blue') {
    return { bgColor: 'blue-8', textColor: 'white' }
  }
  return { bgColor: 'white', textColor: 'black' }
}

function getButtonColorsByKey (key) {
  if (key) {
    if (key.startsWith('yes')) {
      return getButtonColorsByConfigColor('green')
    } else if (key.startsWith('no')) {
      return getButtonColorsByConfigColor('red')
    } else if (key.startsWith('ok')) {
      return getButtonColorsByConfigColor('blue')
    }
  }
  return getButtonColorsByConfigColor(null)
}

export default {
  name: 'AskPropsWindow',
  components: {
    WarningBanner,
    DateTimeField,
    DateIntervalField,
    ItemsSearchField,
    AddressField,
    CardSeparator
  },
  props: {
    config: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      loading: false,
      callback: null,
      header: '',
      warnings: null,
      propsConfig: null,
      buttons: {},
      onOpened: null,
      customComponent: null,
      customComponentProps: {}
    }
  },
  watch: {
    config: {
      handler: function (config) {
        if (config) {
          this.ask(
            config.callback,
            config.header,
            config.propsConfig,
            config.buttons,
            config.warning,
            config.onOpened,
            config.customComponent,
            config.customComponentProps
          )
        } else {
          this.callback = null
          this.header = ''
          this.warnings = null
          this.propsConfig = null
          this.buttons = {}
          this.onOpened = null
          this.customComponent = null
          this.customComponentProps = {}
        }
      },
      immediate: true
    }
  },
  created: function () {
    document.addEventListener('keydown', this.eventHandler)
  },
  mounted: function () {
    if (this.onOpened) {
      this.$nextTick(() => this.$nextTick(() => this.$nextTick(() => {
        this.onOpened(this)
      })))
    }
  },
  beforeDestroy: function () {
    document.removeEventListener('keydown', this.eventHandler)
  },
  methods: {
    ask: async function (callback, header, propsConfig, buttons, warning, onOpened, customComponent, customComponentProps) {
      this.loading = true

      this.callback = callback
      this.header = header || ''
      if (propsConfig != null && Object.keys(propsConfig).length !== 0) {
        const propsConfigCopy = {}
        for (const propKey in propsConfig) {
          if (propsConfig.hasOwnProperty(propKey)) {
            const propConfig = Object.assign({}, propsConfig[propKey])
            propsConfigCopy[propKey] = propConfig
            if (!propConfig.hasOwnProperty('value')) {
              propConfig.value = null
            }
            if (propConfig.value == null) {
              if (propConfig.type === 'boolean') {
                propConfig.value = false
              } else if (propConfig.type === 'datetime') {
                if (propConfig.required) {
                  propConfig.value = this.formatMillis(new Date().getTime())
                }
              } else if (propConfig.type === 'address') {
                propConfig.value = {
                  id: null,
                  type: null,
                  name: null,
                  value: null
                }
              }
            } else {
              if (propConfig.type === 'datetime') {
                propConfig.value = this.formatMillis(propConfig.value)
              } else if (propConfig.type === 'object' && typeof propConfig.value !== 'object') {
                if (propConfig.emitId !== false) {
                  const values = await propConfig.searchConfig.load()
                  propConfig.value = values.find(v => v.id === propConfig.value || v.key === propConfig.value)
                }
              }
            }

            if (propConfig.type === 'text' || propConfig.type === 'textarea') {
              if (propConfig.options && propConfig.options.length) {
                propConfig.optionsShown = false
                propConfig.onSelectOption = function (option) {
                  this.value = option
                }
              }
            }

            if (!propConfig.hideFn) {
              propConfig.hideFn = () => false
            }
          }
        }
        this.propsConfig = propsConfigCopy
      } else {
        this.propsConfig = null
      }

      if (buttons != null && Array.isArray(buttons) && buttons.length) {
        const buttonsConfig = {}
        for (const button of buttons) {
          const key = button.key
          let colors
          if (button.color) {
            colors = getButtonColorsByConfigColor(button.color)
          } else {
            colors = getButtonColorsByKey(key)
          }
          buttonsConfig[key] = Object.assign({ colors, secondary: key && key.startsWith('__') }, button)
        }
        this.buttons = buttonsConfig
      } else if (buttons != null && typeof buttons === 'object' && Object.keys(buttons).length) {
        const buttonsConfig = {}
        for (const key in buttons) {
          buttonsConfig[key] = { name: buttons[key], colors: getButtonColorsByKey(key), secondary: key && key.startsWith('__') }
        }
        this.buttons = buttonsConfig
      } else {
        this.buttons = {
          yes: { name: 'Подтвердить', colors: getButtonColorsByKey('yes') },
          cancel: { name: 'Отмена', colors: getButtonColorsByKey(null) }
        }
      }

      this.warnings = null
      if (warning) {
        if (Array.isArray(warning) && warning.length) {
          this.warnings = warning
        } else if (typeof warning === 'string') {
          this.warnings = [warning]
        }
      }

      this.onOpened = onOpened
      this.customComponent = customComponent || null
      this.customComponentProps = customComponentProps || {}
      this.loading = false

      // this.show()
    },
    confirm: async function (actionKey) {
      if (actionKey.startsWith('cancel')) {
        this.close()

        const button = this.buttons[actionKey]
        if (actionKey !== 'cancel' || button.emitable) {
          this.processResult(null, actionKey)
        }
        return
      }

      const result = {}
      if (this.propsConfig != null) {
        let hasErrors = false
        for (const propKey in this.propsConfig) {
          if (this.propsConfig.hasOwnProperty(propKey)) {
            const propConfig = this.propsConfig[propKey]
            const fields = this.$refs[propKey]
            if (propConfig.required && fields) {
              const field = fields[0]
              if (!field.validate()) {
                hasErrors = true
              }
            }
          }
        }
        if (hasErrors) {
          return
        }

        for (const propKey in this.propsConfig) {
          if (this.propsConfig.hasOwnProperty(propKey)) {
            const propConfig = this.propsConfig[propKey]
            let value = propConfig.value
            if (propConfig.type === 'text') {
              value = value ? value.slice() : ''
            } else if (propConfig.type === 'datetime') {
              value = value ? this.parseMillis(value) : null
              if (value != null && !!propConfig.futureTime && value < (new Date().getTime())) {
                this.$q.notify({
                  type: 'negative',
                  message: 'Должно быть указано будущее время',
                  progress: true,
                  timeout: 8000
                })
                return
              }
            } else if (propConfig.type === 'dateinterval') {
              if (value && value.end && propConfig.notIncludeLastDay) {
                value.end -= 86400000
              }
            } else if (propConfig.type === 'object') {
              if (value && propConfig.emitId !== false) {
                value = value.id || value.key
              }
            }
            result[propKey] = value
          }
        }
      }

      if (this.processResult(result, actionKey)) {
        this.close()
      }
    },
    processResult (result, actionKey) {
      if (this.callback) {
        let success = this.callback(result, actionKey) // throws
        if (success == null) {
          success = true
        }
        return success
      }
      return true
    },
    close () {
      this.hide()
      this.clearValue()
    },
    clearValue () {
    },

    // following methods are REQUIRED ===
    show () {
      this.$refs.dialog.show()
    },
    hide () {
      this.$refs.dialog.hide()
    },
    // ===

    onDialogHide () {
      this.$emit('hide') // REQUIRED to be emitted, when QDialog emits "hide" event
    },
    onOKClick () {
      this.$emit('ok') // REQUIRED; or with payload: this.$emit('ok', { ... })
      this.hide()
    },
    onCancelClick () {
      this.hide()
    },

    formatMillis: function (millis) {
      if (millis) {
        return date.formatDate(millis, 'DD.MM.YYYY HH:mm')
      }
      return null
    },
    parseDate (dateStr) {
      return date.extractDate(dateStr, 'DD.MM.YYYY HH:mm')
    },
    parseMillis (dateStr) {
      return this.parseDate(dateStr).getTime()
    },
    getDateTimeRules (propConfig) {
      const rules = []
      if (propConfig.required) {
        rules.push(val => !!val || 'Обязательное поле!')
      }
      if (propConfig.futureTime) {
        rules.push(value => {
          value = value ? this.parseMillis(value) : null
          if (value != null && value < (new Date().getTime())) {
            return 'Должно быть указано будущее время'
          }
        })
      }
      return rules.length ? rules : undefined
    },
    eventHandler (event) {
      if ((event.ctrlKey || event.shiftKey) && event.code === 'Enter') {
        if (this.buttons.yes) {
          event.preventDefault()

          this.$nextTick(() => {
            setTimeout(() => { // Иначе по событию может сработать активный компонент при закрытом окне
              this.confirm('yes')
            }, 300)
          })
        }
      }
      if (event.code === 'Escape') {
        if (this.buttons.cancel && (this.buttons.cancel.onEscape || !this.propsConfig || Object.keys(this.propsConfig).length === 0)) {
          event.preventDefault()
          this.confirm('cancel')
        }
      }
    }
  }
}
